import { ErrorModal } from "@dexteel/mesf-core";
import { Asset } from "@dexteel/mesf-core/dist/models/Asset";
import { CircularProgress, TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { FieldError } from "react-hook-form";
import { getAssets } from "../repositories/AssetRepository";

type Props = {
  label?: string;
  value: number | null;
  onChange?: Function;
  fieldError?: FieldError | undefined;
  disabled?: boolean;
};

export const AssetAutocomplete = ({
  label = "Asset",
  value,
  onChange = () => {},
  fieldError,
  disabled = false,
}: Props) => {
  const [assets, setAssets] = useState<Asset[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState("");

  const selectedValue = assets.find((asset) => asset.AssetId === value) || null;

  const loadData = async () => {
    setIsLoading(true);
    setError("");
    const resp = await getAssets();
    if (resp.ok) {
      const rows = get(resp, "data.tables[0].rows", []) as Asset[];
      setAssets(rows);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadData().then(() => {});
    return;
  }, []);

  return (
    <>
      <Autocomplete
        id="clear-on-escape"
        clearOnEscape
        options={assets ?? []}
        getOptionLabel={(option) => option.AssetName}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            fullWidth
            size="small"
            error={!!fieldError}
            helperText={fieldError?.message}
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <>
                    {isLoading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : (
                      params.InputProps.endAdornment
                    )}
                  </>
                ),
              },
            }}
          />
        )}
        value={selectedValue}
        onChange={(event, newValue) => {
          onChange(newValue ? newValue.AssetId : null);
        }}
        disabled={disabled}
      />
      <ErrorModal
        error={error}
        onHide={() => setError("")}
        title="Error loading assets"
      />
    </>
  );
};
